export default {
  backend: "https://beta.pgxcloud.com/v1",
  qingstor: "https://pgxcloud-upload-dev.pek3a.qingstor.com",
  urlPrefix: "/public"
}



// WEBPACK FOOTER //
// ./src/app/config.js